module.exports = __webpack_public_path__ + "static/vic-1998-0f4121005813adf83b8a608a65458ab8.png";